import Availabilities from "./Availabilities";
export default Availabilities